export const DEFINITION_FILENAME_TS = "convex.config.ts";
export const DEFINITION_FILENAME_JS = "convex.config.js";
